
import Loading from 'vux/src/components/loading/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import { getEvaluation, getEvaluationCal } from 'api/evaluation'
import signHandle from './signHandle'
export default {
components: {
Loading,
XHeader,
Group,
Radio,
XButton,
Flexbox,
FlexboxItem
},
filters: {
formatAnswer (content, i) {
return `${String.fromCharCode(65 + i)}. ${content}`
}
},
data () {
return {
params: '',
loading: true,
show: false,
isSubmit: false,
list: {
sysCode: '',
pageSize: 100,
managerAdminUserId: ''
},
index: 1,
question: [],
subData: {
sysCode: '',
managerAdminUserId: '',
userId: '',
loginUserId: '',
answerJsonStr: '',
version: ''
}
}
},
created () {
this.params = this.$route.query
this.$vux.loading.show({text: '加载中'})
this.judgeNeedSign()  
this.$_evaluation_set()
},
computed: {
total () {
return this.question.length
},
prevStyle () {
return this.index === 1 ? {'color': '#ccc'} : {'color': '#666666'}
},
nextStyle () {
return this.index === this.total ? {'color': '#ccc'} : {'color': '#666666'}
},
progressPercent () {
let endNum = 0
if (this.question.every((item, index) => { return item.checked === '' })) {
return 0
}
this.question.forEach((item, index) => {
if (item.checked) {
endNum = endNum + 1
}
})
return `${Math.ceil((endNum / this.total) * 100)}%`
}
},
methods: {
$_evaluation_set () {
this.list.sysCode = this.params.sysCode
this.list.managerAdminUserId = this.params.managerId
this.subData.managerAdminUserId = this.params.managerId
this.subData.userId = this.params.invenstemUserId       
this.subData.sysCode = this.params.sysCode
this.subData.loginUserId = this.params.userId
this.subData.version = this.params.version
this.$_evaluation_init()
},
$_evaluation_init () {
let _this = this
setTimeout(() => {
getEvaluation(this.list, this.params.au).then((res) => {
_this.loading = false
_this.$vux.loading.hide()
if (res.data.list.length) {
const dataList = res.data.list[0].questionInfos
_this.question = dataList.map((item, index) => {
let answerItem = item.answerList.map((v, k) => {
return {key: v.answerId + '', value: v.answerContent}
})
return {title: item.questionContent, key: item.questionKey, checked: '', options: answerItem}
})
console.log(_this.question)
} else {
_this.$vux.alert.show({
title: '提示',
content: '当前机构或个人没有风险评测问卷',
onHide () {
_this.$router.go(-1)
}
})
}
})
}, 500)
},
$_evaluation_back () {
let _this = this
if (_this.question[0].checked) {
_this.$vux.confirm.show({
title: '提示',
content: '退出将不会保存当前的评测结果，是否继续？',
onCancel () {
console.log('plugin cancel')
},
onConfirm () {
_this.$router.go(-1)
}
})
} else {
_this.$router.go(-1)
}
},

change (index) {
setTimeout(() => {
if (index === this.total) {
this.isSubmit = true
} else {
if (this.question[index - 1].checked) {
this.index = index + 1
}
}
}, 300)
},

$_evaluation_next (index) {
if (index === this.total) {
return
}
if (this.question[index - 1].checked) {
this.index = index + 1
} else {
this.$vux.toast.show({text: `请选择符合您的选项`, type: 'warn', position: 'middle'})
}
},

$_evaluation_prev (index) {
if (index === 1) {
return
}
this.index = index - 1
},


judgeRisk (level, orglevel) {
console.log('测评结果：' + level, '原始风险等级：' + orglevel)
let specialObj = this.$util.toBoolean(this.params.specialObj)
if (specialObj) {
if (level === 'C1') {
return 1
} else {
return 2
}
} else {
if (orglevel === '最低风险等级' && level !== 'C1') {
return 2
}
return (level === 'C1') ? 1 : (parseInt(level.split('C')[1]) >= parseInt(orglevel.split('C')[1]) ? 2 : 3)
}
},

async judgeNeedSign () {
/* ----------- 2020.7.23 versiont: 1.14  删除风险测评配置是否需要签署, 改为全部签署 ------------ */







this.params.isNeedSign = 1
},
showPlugin () {
let vm = this
this.$vux.confirm.show({
title: '温馨提示',
content: '本人已经了解并愿意遵守国家有关证券市场、基金市场管理的法律、法规、规章及相关业务规则，本人在此郑重承诺以上填写的内容真实、准确、完整。若本人提供的信息发生任何重大变化，本人将及时书面通知贵公司。',
onConfirm () {
if (vm.params.re === 2) {
signHandle(vm)
return
}
if (vm.params.re === 3) {
signHandle(vm)
}
}
})
},

$_evaluation_submitCal (index) {
let quesJson = []
if (this.question[index - 1].checked) {
this.question.map((item) => {
quesJson.push({questionKey: item.key, answerId: item.checked})
})
this.subData.answerJsonStr = JSON.stringify(quesJson)

getEvaluationCal(this.subData, this.params.au).then((res) => {
if (res.code === 0) {
this.params.subData = JSON.stringify(this.subData)

this.params.evaluationResultFile = res.data.bean.evaluationResultFile
this.params.result = res.data.bean.evaluationResult
this.params.orgResult = res.data.bean.lastEvaluationResult || ''


this.params.re = this.judgeRisk(this.params.result, this.params.orgResult)
console.log('分析页面跳转状态结果：' + this.params.re)

if (this.params.re === 1) {
this.$router.push({path: '/evaluation/lastlow', query: this.params})
return
}

if (this.params.re === 2) {
this.$router.push({path: '/evaluation/normal', query: this.params})
return
}

if (this.params.re === 3) {
this.$router.push({path: '/evaluation/batchlow', query: this.params})
return
}

} else {
this.isSubmit = true
this.$vux.toast.show({type: 'warn', text: res.msg})
}
})
} else {
this.$vux.toast.show({text: `请选择符合您的选项`, type: 'warn', position: 'middle'})
}
},



















$_evaluation_set_prefix (index) {
let arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N']
return arr[index]
}
}
}



// WEBPACK FOOTER //
// ./src/components/Evaluation/Question.vue